export function appReload() {
    let url = window.location.href
    url = url.split('/#');
    var url1 = url[0].split('/?')[0];
    var time = new Date().getTime();
    var href = url1 + '?time=' + time + '/#' + url[1];
    window.location.replace(href);
}


// WEBPACK FOOTER //
// ./src/utils/location.js